import {
  useState
} from 'react'
import {
  optOutOfTracking
} from '../analytics/posthog'

// Lightweight cookie/analytics consent for public guest pages (e.g. the
// /stays and /flights options pages). Recording is on by default (the app-wide
// PostHog init); declining opts the visitor out of all capture. The decision is
// remembered under `storageKey` so the banner shows only once per page family.
export function CookieConsentBanner({
  storageKey
}: {
  storageKey: string
}): JSX.Element | null {
  const [decided, setDecided] = useState<boolean>(() => {
    try {
      return localStorage.getItem(storageKey) != null
    } catch {
      return true
    }
  })

  if (decided) {
    return null
  }

  const decide = (choice: 'accepted' | 'declined'): void => {
    try {
      localStorage.setItem(storageKey, choice)
    } catch {
      // localStorage unavailable (private mode) — proceed without persisting.
    }
    if (choice === 'declined') {
      optOutOfTracking()
    }
    setDecided(true)
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 border-t border-catch-beige-dark bg-catch-white px-4 py-3 shadow-soft-lg">
      <div className="mx-auto flex max-w-3xl flex-col items-center gap-2 text-center text-xs text-gray-600 sm:flex-row sm:justify-between sm:text-left">
        <span>
          Catch uses cookies to see how this page is used and improve it. See our{' '}
          <a
            href="/privacy"
            target="_blank"
            rel="noreferrer"
            className="underline hover:text-catch-black"
          >
            Privacy Policy
          </a>
          .
        </span>
        <span className="flex shrink-0 gap-2">
          <button
            type="button"
            onClick={() => decide('declined')}
            className="rounded-full border border-catch-beige-dark px-3 py-1 hover:border-gray-300"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={() => decide('accepted')}
            className="rounded-full bg-catch-red px-3 py-1 font-medium text-catch-white hover:opacity-90"
          >
            Accept
          </button>
        </span>
      </div>
    </div>
  )
}
